const VueTable2Checkbox = {
    install(Vue, options) {
        Vue.component(
            'vuetable2-checkbox',
            require('./components/checkbox.vue'),
        );
        Vue.component('vuetable2-heading', require('./components/heading.vue'));
        Vue.component(
            'vuetable2-header-action',
            require('./components/header-action.vue'),
        );
    },
};

export default VueTable2Checkbox;



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/index.js